import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import _startCase from 'lodash/startCase';
import { StatTab } from '@m12s/component-library';

export const JobsTab = () => {
  const { t } = useTranslation();
  const cardCount = useSelector((state) => {
    return state.workOrderManagement.jobCardCount;
  });

  return (
    <StatTab
      id="jobs-tab"
      value="jobs"
      label={_startCase(t('jobs'))}
      secondaryLabel={cardCount}
    />
  );
};
